import * as React from "react";
import { RadioButton } from "./radio";
import { useTranslation } from "react-i18next";
// ListModeSelector
// ***********************************************************************************************************************

/* eslint-disable no-unused-vars */
export const enum ListMode {
    List = "0",
    Card = "1",
}
/* eslint-enable no-unused-vars */

export interface IListModeSelectorProp {
    classes?: string;
    disabled?: boolean;
    listMode: ListMode;
    onChangeListMode: (listMode: ListMode) => void;
}

export const ListModeSelector: React.FC<IListModeSelectorProp> = (props) => {
    const { t } = useTranslation();
    const listModes = [
        { title: t("common.card"), mode: ListMode.Card, classes: " grid" },
        { title: t("common.list"), mode: ListMode.List, classes: " list" }
    ];
    return (
        <div className={"btn-group btn-group-toggle states" + (props.classes ? " " + props.classes : "")}>
            {listModes.map((listMode) =>
                <RadioButton
                    key={listMode.mode}
                    classes={"btn-secondary state" + listMode.mode + listMode.classes}
                    enabled={true}
                    checked={props.listMode === listMode.mode}
                    onRadioClick={() => { props.onChangeListMode(listMode.mode); }}
                />
            )}
        </div>
    );
};
